import React from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../../components/breadcrumbs/Breadcrumbs";
import _image_service from "../../../../../../../services/ImageService";
import '../../../../../../styles/Common.scss';
import '../../../WorldPages.scss';
import '../MagicItemsPage.scss';

interface MagicTomePageProps {
}

const MagicTomePage = (props: MagicTomePageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok: Magic Tomes - Chase the Fox`,
        description: "Tomes are spellbooks infused with magic power that can enhance a magic user's abilities in Casarok!",
        keywords: ["casarok", "magic", "magic compendium", "magic item", "magical", "magical item", "magic tome", "tome"],
        imgSrc: `chase/world/magic/items/tome.png`,
        url: `world/magic/items/tome`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Tomes">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <img className="magic-item-pic right"
                         src={_image_service.getCdnImageSrc(`chase/world/magic/items/tome.png`)}
                         alt="A red latched book with the Casarokan symbol for fire magic printed on the front"
                         title="A simple reprint of a fire magic tome"/>
                    <p>
                        Magical tomes are spellbooks that are infused with power. Not only do they act as a resource to
                        look up the details of a spell, but they also provide some latent energy to call upon for
                        spellcasting. Tomes are enchanted using special runes that adorn the cover or outer pages. The
                        International Council of Magic has long prohibited runes in tomes from being buried beyond the
                        first few pages of a tome to prevent those who seek to do harm from hiding them. These
                        enchanting runes can have various effects like increasing the power of a spell, decreasing the
                        cost of casting a spell, or resistance against certain spells. The types of spells can involve a
                        range of <NavLink className="world-link" to="/world/magic/elements">elements</NavLink> or can
                        even cover entire <NavLink className="world-link" to="/world/magic/elements">schools</NavLink>
                        of magic at a time.
                    </p>
                    <p>
                        Tomes have been in use throughout the history of Casarok. They were rare and expensive early
                        in the <NavLink className="world-link" to="/world/history">pre-Cataclysmic</NavLink> era until
                        the invention of the printing press. They were also arguably more powerful as they could be
                        enchanted by drawing upon the power of
                        a <NavLink className="world-link" to="/world/religion/pantheon">god or goddess</NavLink> to
                        imbue it with immense power. Such tomes are some of the most powerful and sought after of all
                        time. However, almost all of them were lost
                        to <NavLink className="world-link" to='/world/history/cataclysmic-age'>the Great Cataclysm</NavLink> as
                        most history was from that time was. Those that remain are powerful artifacts unearthed by
                        archaeologists and historians. Some may have been kept and maintained in the fabled Frozen
                        Archives. Most anthros fear what could happen if one of the pre-Cataclysmic tomes were placed
                        in the hands of a magic user who wishes to do great harm.
                    </p>
                    <p>
                        Magic tomes continue to be created in the post-Cataclysmic era. Special printing presses that
                        utilize <NavLink className="world-link" to="/world/magic/items/mage-tech">mage-tech</NavLink> allow
                        for the rapid creation of tomes. Mass-produced tomes do not have the same level of power as
                        those which are written or enchanted by hand. In fact, most of the tomes created
                        in <NavLink className="world-link" to="/world/history/modern-age">modern times</NavLink>, don't
                        have the same runic power as those created in the past. It is a general rule of thumb in
                        Casarok that the older a tome, the more powerful it likely is.
                    </p>
                </div>
            </ContentBox>
        </>
    );
}

export default MagicTomePage;